import { FirebaseError } from 'firebase/app';

/** A message fit for people, from Firebase/callable errors. */
export function friendlyError(err: unknown): string {
  if (err instanceof FirebaseError) {
    // Callable errors carry our own user-facing messages.
    if (err.code.startsWith('functions/') && err.code !== 'functions/internal') return err.message;
    if (err.code === 'auth/popup-closed-by-user' || err.code === 'auth/cancelled-popup-request')
      return '';
    if (err.code === 'auth/popup-blocked')
      return 'Your browser blocked the sign-in window. Allow pop-ups and try again.';
    if (err.code === 'storage/unauthorized')
      return 'That upload was not allowed. Images must be under 1 MB.';
    if (err.code.includes('network') || err.code === 'unavailable')
      return 'You seem to be offline. Try again.';
  }
  if (err instanceof Error && err.message) return err.message;
  return 'Something went wrong. Please try again.';
}
